<template>
  <div id="wangeditor">
    <div id="editorElem" style="width:650px;"></div>
  </div>
</template>

<script>
import E from "wangeditor";
import axios from "axios";
export default {
  data() {
    return {
      editor: Object,
      qiniuData: {},
      domain: null,
      headers: {}
    };
  },
  watch: {
    value: {
      handler: function () {
        this.editor.txt.html(this.value);
      },
    },
    disabled(newValue) {
      if (newValue) {
        this.editor.disable();
      } else {
        this.editor.enable();
      }
    },
  },
  destroyed() {
    this.isChange = false;
  },
  props: ["value", "disabled"],
  created() {
    this.isChange = false;
  },
  mounted() {
    // this.isChange = false;
    this.getQiniuToken();
    this.headers = { Authorization: localStorage.getItem("token") };
    let that = this;
    this.editor = new E("#editorElem");
    this.editor.config.onchange = (newHtml) => {
      that.$emit("input", newHtml);
    };

    this.editor.config.customUploadImg = function (resultFiles, insertImgFn) {
      // resultFiles 是 input 中选中的文件列表
      // insertImgFn 是获取图片 url 后，插入到编辑器的方法
      // console.log(resultFiles);
      that.qiniuData.key =
        "" +
        new Date().getTime() +
        Math.round(Math.random() * 10000) +
        "." +
        resultFiles[0].name.split(".")[
          resultFiles[0].name.split(".").length - 1
        ];
      var formData = new FormData();
      formData.append("token", that.qiniuData.token);
      formData.append("file", resultFiles[0]);
      formData.append("key", that.qiniuData.key);

      //上传图片方法写在这
      axios.post(that.action, formData).then((res) => {
        // console.log(that.domain + res.data.key);
        //上传图片，返回结果，将图片插入到编辑器中
        insertImgFn(that.domain + res.data.key);
      });
    };
    // 配置触发 onchange 的时间频率，默认为 200ms
    this.editor.config.onchangeTimeout = 500; // 修改为 500ms
    this.editor.create();

    if (this.disabled) {
      this.editor.disable();
    } else {
      this.editor.enable();
    }

    this.editor.txt.html(this.value); // 重新设置编辑器内容
  },
  methods: {
    //获取七牛token
    getQiniuToken() {
      this.request.qiniuUploadToken().then((res) => {
        this.qiniuData.token = res.data.uptoken;
        this.domain = res.data.domain;
        this.action = res.data.upload;
      });
    },
  },
};
</script>

<style>
</style>